import resolveKioskApp from '../../../shared/experiences/resolveKioskApp'
import { buildForwardedKioskParams, resolveKioskLaunchSettings } from '../../../shared/helpers/forwardedKioskSettings'
import { getURLParams } from '../../../shared/helpers/url_helper'
import { getSessionStorageItem, setSessionStorageItem } from '../../../shared/helpers/sessionStorage'
import validateCenterCode from './validateCenterCode'

export default async function getKiosk(appFromNav) {
  const params = getURLParams(window.location.search)
  const cachedKioskSettings = getSessionStorageItem('kioskSettings') ?? {}
  let kioskSettings
  if (params.center) {
    kioskSettings = params
  } else {
    kioskSettings = cachedKioskSettings
  }
  // URL params use 'center', but sessionStorage uses 'centerCode'
  const lowerCasedCenter = (kioskSettings?.center || kioskSettings?.centerCode)?.toLowerCase()
  const { app, appSettings: APP } = resolveKioskApp({
    urlApp: params.app,
    cachedApp: cachedKioskSettings.app,
    routerApp: appFromNav,
  })

  // Validate center code
  const { centerCode, warning: invalidCenterWarning } = await validateCenterCode(lowerCasedCenter)

  const launchSettings = resolveKioskLaunchSettings(params, cachedKioskSettings)
  const kioskQueryString = `?${buildForwardedKioskParams({ ...launchSettings, center: centerCode, app }).toString()}`

  const kiosk = {
    centerCode,
    app,
    redirect: APP.redirect ?? 'https://www.familysearch.org/discovery/about/kiosk',
    baseKeyCodeUndockRedirect: APP.keyCodeUndockRedirect,
    keyCodeUndockRedirect: APP.keyCodeUndockRedirect ? `${APP.keyCodeUndockRedirect}${kioskQueryString}` : '',
    unauthRedirect: APP.unauthRedirect,
    title: APP.title,
    timeOut: 600,
    invalidCenterWarning, // Add warning message if center was invalid
    ...launchSettings,
  }

  if (
    !getSessionStorageItem('kioskSettings') ||
    params.app !== kiosk.app ||
    params.center !== kiosk.centerCode ||
    cachedKioskSettings.onboarding !== kiosk.onboarding ||
    cachedKioskSettings.defaultLanguage !== kiosk.defaultLanguage
  )
    setSessionStorageItem({ kioskSettings: kiosk })

  return { ...kiosk }
}
